import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home-pages/home/home').then((m) => m.HomeComponent),
  },
  {
    path: 'fix-sessions/:session_id',
    loadComponent: () => import('./pages/home-pages/fix-session/fix-session').then((m) => m.FixSessionComponent),
  },
  // {
  //   path: 'accounts/:account_id',
  //   loadComponent: () => import('./pages/home-pages/account/account').then((m) => m.AccountComponent),
  // },
  {
    path: 'operations',
    loadComponent: () => import('./pages/operations-pages/operations/operations').then((m) => m.OperationsComponent),
  },
  {
    path: 'operations/:operation_id',
    loadComponent: () =>
      import('./pages/operations-pages/operation-details/operation-details').then((m) => m.OperationDetailsComponent),
  },
  // {
  //   path: 'settings',
  //   loadComponent: () => import('./pages/settings-pages/settings/settings').then((m) => m.SettingsComponent),
  // },
  // {
  //   path: 'settings/accounts',
  //   loadComponent: () => import('./pages/settings-pages/accounts/accounts').then((m) => m.AccountsComponent),
  // },
  // {
  //   path: 'settings/accounts/:account_id',
  //   loadComponent: () =>
  //     import('./pages/settings-pages/account-details/account-details').then((m) => m.AccountDetailsComponent),
  // },
  {
    path: 'settings/users',
    loadComponent: () => import('./pages/settings-pages/users/users').then((m) => m.UsersComponent),
  },
  // {
  //   path: 'settings/market-data',
  //   loadComponent: () => import('./pages/settings-pages/market-data/market-data').then((m) => m.MarketDataComponent),
  // },
  {
    path: 'reference-data/instruments',
    loadComponent: () => import('./pages/reference-pages/symbols/symbols').then((m) => m.SymbolsComponent),
  },
  {
    path: 'reference-data/currencies',
    loadComponent: () => import('./pages/reference-pages/currencies/currencies').then((m) => m.CurrenciesComponent),
  },
  {
    path: 'reference-data/fx-calendar',
    loadComponent: () => import('./pages/reference-pages/fx-calendar/fx-calendar').then((m) => m.FxCalendarComponent),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
